import { ToastType } from 'components/Toast/types'
import Icon from 'components/Icon'

export type ToastStyleProps = {
  [k in ToastType]: {
    icon: JSX.Element
    style: string
  }
}

export const ToastStyleProps: ToastStyleProps = {
  success: {
    icon: <Icon name="success" color="element-inverse" />,
    style: 'success',
  },
  alert: {
    icon: <Icon name="error" color="element-inverse" />,
    style: 'alert',
  },
  informative: {
    icon: <Icon name="service-order" color="element-inverse" />,
    style: 'informative',
  },
}
